export default {
   /* eslint-disable key-spacing */
   '01': 'PT',
   '02': 'CV',
   '03': 'Bukan Badan Usaha',
   '04': 'Badan Usaha Pemerintah',
   '05': 'Persekutuan Firma (Fa)',
   '06': 'Kongsi',
   '07': 'Koperasi',
   '08': 'Dana Pensiun',
   '09': 'Persyarikatan atau Perkumpulan',
   10: 'Yayasan',
   11: 'Organisasi',
   12: 'Organisasi Sosial Politik',
   13: 'Organisasi Lainnya',
   14: 'Lembaga dan Bentuk Lainnya',
   15: 'Kontrak Investasi Kolektif',
   16: 'Bentuk Usaha Tetap (BUT)',
   17: 'Perorangan',
   18: 'Badan Layanan Umum (BLU)',
   19: 'Badan Hukum Lainnya',
   20: 'Badan Usaha Lainnya',
   21: 'Perusahaan Umum (Perum)',
   22: 'Perusahaan Umum Daerah (Perumda)',
   23: 'Perusda',
   24: 'Badan Operasi Bersama (BOB)',
   25: 'Badan Usaha Perwakilan',
   26: 'PT Perorangan',
   27: 'Pedagang Berjangka Asing (PBA)',
   28: 'Badan Usaha Milik Desa (BUM Desa)',
   29: 'Badan Usaha Milik Desa Bersama (BUM Desa Bersama)',
   /* eslint-enable key-spacing */
}
